var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolRefugeArea = function SvgFiremapSymbolRefugeArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.308 4h-2.693l-1.062-2.157h-1.255V16H8.308V8h3.732c2.145 0 3.378 1.027 3.378 2.842 0 1.186-.48 2.054-1.347 2.545zm-5.01-6.174v2.191h1.358c.708 0 1.118-.388 1.118-1.107 0-.696-.41-1.084-1.118-1.084z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolRefugeArea;